// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"18":"results","177":"home"}[chunkId] || chunkId) + "." + {"18":"06cd5c3f","177":"30692ec8","565":"8460feec"}[chunkId] + ".css";
};